import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash';
import { injectIntl } from 'react-intl';
import ListingImage from '../ListingImage';
import Link from '../SEO/Link';
import { PortalConfigContext } from '../../config/portal';
import { BREAKPOINTS } from '../../utils/commonHelper';
import { getSellerName } from '../../utils/listingHelper';
import { listingPropTypes } from '../../utils/commonPropTypes';
import { getBoatUrl } from '../../utils/urlHelpers/boat';
import ContactForm from '../ContactForm';
import messages from '../../utils/translationMessages';
import { getCurrentBoats as bts } from '../../utils/language';
import { setListingClick } from '../../store/actions/dataLayer';
import './styles.css';
import './card.css';

class ListingResult extends PureComponent {
  state = {
    contactOpen: false
  }

  displayContactFormData = [];

  ENHANCED = 'enhanced listing';

  STANDARD = 'standard listing';

  RESIZES = {
    default: { width: 300, height: 222 },
    rowEnhanced: { width: 400, height: 267 },
    cardMobile: { width: 300, height: 194 },
    cardLargeMobile: { width: 160, height: 120 },
    cardTablet: { width: 229, height: 120 },
    cardDesktop: { width: 296, height: 194 }
  };

  getResize() {
    if (this.props.mode === ListingResult.MODES.card) {
      if (this.props.breakpoint === BREAKPOINTS.mobile) {
        return this.RESIZES.cardMobile;
      }
      if (this.props.breakpoint === BREAKPOINTS.tablet) {
        return this.RESIZES.cardTablet;
      }
      return this.RESIZES.cardDesktop;
    }
    if (get(this.props.listing.featureType, 'enhanced', false)) {
      return this.RESIZES.rowEnhanced;
    }
    return this.RESIZES.default;
  }

  getListingType() {
    const { listing, listingType } = this.props;
    if (listingType) {
      return listingType;
    }
    return get(listing.featureType, 'enhanced', false) ? this.ENHANCED : this.STANDARD;
  }

  componentDidMount() {
    const { listing, position, tracking } = this.props;
    const listingType = this.getListingType();
    const { id } = listing;
    tracking.setProductImpression(id, listingType, position.position, position.page);
  }

  handleContactButtonClick = (e) => {
    e.stopPropagation();
    this.displayContactFormData = [];
    if (!this.state.contactOpen) {
      let { listing } = this.props;
      const lengthUOM = get(this.context, 'uom.length.abbr', 'ft');
      let contactData = {
        boatClass: listing.class,
        make: listing.make,
        listingType: bts().LISTING_ENHANCED,
        length: `${get(listing.specifications.dimensions.lengths.nominal, lengthUOM, '')}`,
        subdivision: listing.location.address.subdivision
      };
      this.displayContactFormData.push(
        <ContactForm
          key={listing.id}
          open={!this.state.contactOpen}
          itemId={listing.id}
          data={contactData}
          onClose={this.handleContactButtonClose}
        />
      );
    }
    this.setState({ contactOpen: !this.state.contactOpen });
  }

  handleContactButtonClose = () => {
    this.setState({ contactOpen: !this.state.contactOpen });
    this.displayContactFormData = [];
  }

  getDealerLogo = () => {
    const { listing } = this.props;
    return get(listing.owner, 'logos.enhanced', '').replace(/^http:\/\//, 'https://');
  }

  getDealerName = () => {
    const { listing } = this.props;
    return get(listing.owner, 'name', '');
  }

  render() {
    const { listing, position, itemCount, intl: { formatMessage: t }, labels, mode } = this.props;
    const { getPrice, getTitle, getLocation } = labels;
    const title = getTitle(listing);
    const price = getPrice(listing);
    const listingType = this.getListingType();

    const resize = this.getResize();
    const location = getLocation(listing);

    const listingAnchorParamsDefault = {
      'data-reporting-click-product-id': listing.id,
      'data-reporting-click-listing-type': listingType,
      'data-reporting-rank': position.position,
      'data-reporting-page': position.page
    };
    const listingAnchorParams = {
      ...listingAnchorParamsDefault,
      href: getBoatUrl(listing)
    };

    const seller = getSellerName(listing.owner);

    return (
      <li
        className={classnames('listing-result', `listing-result-${mode}`,
          { 'listing-result-enhanced': get(listing.featureType, 'enhanced', false) })}
        data-listing-id={listing.id}
        data-reporting-impression-product-id={listing.id}
        data-reporting-impression-listing-type={listingType}
        onClick={ () => setListingClick(listing.id, listingType, '', '') }
      >
        {this.displayContactFormData}
        <div className="inner" >
          <div className="image-container">
            <div className="dummy" />
            <div className="image">
              <Link {...listingAnchorParams} >
                <ListingImage listing={listing} resize={resize} labels={labels} lazyLoad={itemCount > 4} />
              </Link>
            </div>
          </div>
          <div className="description">
            <div className="top">
              <div className="name">
                <Link className="main-link" {...listingAnchorParams}>
                  <h2 className="visuallyhidden">{title}</h2>
                </Link>
                <h2>{title}</h2>
              </div>

              <div className="price">
                {price}
              </div>
              <div className="location">
                {location}
              </div>
            </div>
            {mode !== ListingResult.MODES.card && (
              <div className="bottom">
                {listingType === this.ENHANCED ? (
                  <>
                    <div className="dealer">
                      { this.getDealerLogo() &&
                        <img className="dealer-logo" src={this.getDealerLogo()} alt={this.getDealerName()} />
                      }
                      <div className="offered-by">
                        <span className="sold-by">{t(messages.contactGroup.offeredBy) + ': '}</span>
                        {seller}
                      </div>
                    </div>
                    <div className="contact">
                      <a
                        className="contact-seller"
                        {...listingAnchorParamsDefault}
                        onClick={this.handleContactButtonClick}>
                        {t(messages.contactGroup.contact)}
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="offered-by">
                    {seller}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </li >
    );
  }
}

ListingResult.contextType = PortalConfigContext;

ListingResult.MODES = {
  card: 'card',
  row: 'row'
};

ListingResult.defaultProps = {
  listingType: '',
  mode: ListingResult.MODES.row
};

ListingResult.propTypes = {
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  /** Helper functions to build listing labels */
  labels: PropTypes.shape({
    getLocation: PropTypes.func.isRequired,
    getPrice: PropTypes.func.isRequired,
    getTitle: PropTypes.func.isRequired,
  }).isRequired,
  /** Listing information of the boat */
  listing: listingPropTypes.isRequired,
  /** Listing type used for tracking and reporting */
  listingType: PropTypes.string,
  mode: PropTypes.oneOf(Object.keys(ListingResult.MODES)),
  /** Position within the results list */
  position: PropTypes.shape({
    position: PropTypes.number,
    page: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  /** Analytics tracking helper  */
  tracking: PropTypes.shape({
    setProductImpression: PropTypes.func.isRequired,
  }).isRequired,
  itemCount: PropTypes.number,
};

export default injectIntl(ListingResult);
